import Card from "components/card";
const General = () => {
  return (
    <Card extra={"w-full h-full p-3"}>
      {/* Header */}
      <div className="mt-2 mb-8 w-full">
        <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white">
          Descripcion perfil
        </h4>
        <p className="mt-2 px-2 text-base text-gray-600">
        Un ingeniero es un profesional altamente capacitado y versátil que aplica principios científicos, matemáticos y técnicos para diseñar, analizar, desarrollar y mantener estructuras, sistemas y procesos en una amplia gama de industrias. La ingeniería es una disciplina dinámica y en constante evolución que abarca numerosas especialidades, incluyendo pero no limitado a la ingeniería civil, mecánica, eléctrica, química, informática y aeroespacia
        </p>
      </div>
      {/* Cards */}
      <div className="grid grid-cols-2 gap-4 px-2">
        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Educacion</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            Universidad Nacional
          </p>
        </div>

        <div className="flex flex-col justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Lenguajes</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            English, Spanish, Italian
          </p>
        </div>

        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Area</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            Sistemas
          </p>
        </div>

        <div className="flex flex-col justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Historia</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            English, Spanish, Italian
          </p>
        </div>

        <div className="flex flex-col items-start justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Organizacion</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            Apoyo Legal 
          </p>
        </div>

        <div className="flex flex-col justify-center rounded-2xl bg-white bg-clip-border px-3 py-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <p className="text-sm text-gray-600">Cumpleaños</p>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            20 Julio 1986
          </p>
        </div>
      </div>
    </Card>
  );
};

export default General;
